type PageObject = {
  name: string
  description: string
}

type ImpactModulePages = {
  [key: string]: PageObject
}

export const REGULATION_PAGES: ImpactModulePages = {
  GROUP_MODULE_PERMISSION: {
    name: 'Permissões de grupos',
    description: 'Gestão das permissões dos grupo',
  },
  PUBLIC_AGENT_MODULE_PERMISSION: {
    name: 'Permissões dos agentes',
    description: 'Gestão das permissões dos agentes públicos',
  },
  REGULATORY_AGENT: {
    name: 'Reguladores',
    description: 'Gestão dos reguladores',
  },
  SERVICE: {
    name: 'Serviços regulados',
    description: 'Gestão dos serviços regulados',
  },
  PANEL: {
    name: 'Regulação das solicitações',
    description: 'Gestão do regulação das solicitações',
  },
  SERVICE_REQUEST: {
    name: 'Visualização das solicitações',
    description: 'Gestão das visualização das solicitações',
  },
  SERVICE_REQUEST_DASHBOARD: {
    name: 'Relatório das solicitações',
    description: 'Gestão do relatório das solicitações',
  },
}
